import "@/polyfills";
import React from "react";
import ReactDOM from "react-dom/client";
import axios from "axios";
import "@/index.css";
import App from "@/App";
import { setupGlobalErrorLogging } from "@/utils/errorReporter";

setupGlobalErrorLogging(axios);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register PWA Service Worker with update handling + background sync
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then((reg) => {
        console.log('SW registered:', reg.scope);

        // Check for updates periodically (every 30 min)
        setInterval(() => reg.update(), 30 * 60 * 1000);

        // When a new SW is found and installed, notify the app
        reg.addEventListener('updatefound', () => {
          const newWorker = reg.installing;
          if (!newWorker) return;
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              // New version is installed and waiting — dispatch event so UI can show toast
              window.dispatchEvent(new CustomEvent('sw-update-available', { detail: { registration: reg } }));
              console.log('New service worker installed. Waiting for activation.');
            }
          });
        });

        // Register periodic background sync for data refresh
        registerPeriodicSync(reg);
      })
      .catch((err) => console.log('SW registration failed:', err));

    // Clear API cache on login/logout so stale user data isn't served
    window.addEventListener('auth-change', () => {
      if (navigator.serviceWorker.controller) {
        navigator.serviceWorker.controller.postMessage('CLEAR_API_CACHE');
      }
    });

    // Listen for messages from the service worker
    navigator.serviceWorker.addEventListener('message', (event) => {
      if (event.data?.type === 'OFFLINE_QUEUE_DRAINED') {
        window.dispatchEvent(new CustomEvent('offline-queue-drained', { detail: { count: event.data.count } }));
      }
    });

    // When coming back online, trigger a sync drain
    window.addEventListener('online', () => {
      if (navigator.serviceWorker.controller) {
        navigator.serviceWorker.controller.postMessage('DRAIN_OFFLINE_QUEUE');
      }
    });
  });
}

async function registerPeriodicSync(registration) {
  try {
    if ('periodicSync' in registration) {
      const status = await navigator.permissions.query({ name: 'periodic-background-sync' });
      if (status.state === 'granted') {
        await registration.periodicSync.register('ccc-refresh-data', {
          minInterval: 15 * 60 * 1000, // 15 minutes minimum
        });
        console.log('Periodic background sync registered');
      }
    }
  } catch (e) {
    // Periodic sync not supported or denied — not critical
  }
}
